import {ReactNode, Suspense} from 'react';

import Loader from '@patientpattern/coat/ui/Loader';

type SuspendProps = {
    child: ReactNode;
};

const Suspend = ({child}: SuspendProps) => (
    <Suspense fallback={<Loader />}>{child}</Suspense>
);

export default Suspend;
